// 纳排
import axios from './Interceptor.js';
let address = window.global_config.BASE_URL2;
let naPai = {
  GetProjectRuleListByProjectId: data => {
    // 基础数据
    return axios({
      method: 'get',
      url: `${address}ProjectRule/GetProjectRuleListByProjectId?ProjectId=${data}`
    });
  },
  AddList: data => {
    // 基础数据
    return axios({
      method: 'post',
      url: `${address}ProjectRule/AddList`,
      data: data
    });
  },
  // 根据项目和问卷查询纳排
  getList: ({ ProjectId, Qid }) => {
    // 基础数据
    return axios({
      method: 'get',
      url: `${address}ProjectRule/GetProjectRuleListByProjectIdAndQid?ProjectId=${ProjectId}&Qid=${Qid}`
    });
  }
};

export default naPai;
